import { differenceInSeconds } from 'date-fns'

function formatDuration(secondsDiff) {
  const isNegative = secondsDiff < 0
  const absoluteSeconds = Math.abs(secondsDiff)

  const hours = Math.floor(absoluteSeconds / 3600)
  const minutes = Math.floor((absoluteSeconds % 3600) / 60)
  const seconds = Math.floor(absoluteSeconds % 60)

  const sign = isNegative ? '-' : ''
  const paddedSeconds = seconds.toString().padStart(2, '0')
  const paddedMinutes = minutes.toString().padStart(2, '0')

  if (hours != 0)
    return `${sign}${hours}:${paddedMinutes}:${paddedSeconds}`

  return `${sign}${paddedMinutes}:${paddedSeconds}`
}

export default ({ startedAt, size = 'big', onTick, timeout }) => {
  const [currentDisplay, setCurrentDisplay] = useState('00:00')
  const [seconds, setSeconds] = useState(0)

  useEffect(() => {
    const interval = setInterval(() => {
      let newSeconds = differenceInSeconds(new Date(), startedAt)

      if(!isNaN(timeout)) newSeconds = timeout - newSeconds

      const formatted = formatDuration(newSeconds)

      if(onTick) {
        onTick({ newSeconds, formatted })
      }

      setCurrentDisplay(formatted)
      setSeconds(newSeconds)
    }, 1000)

    return () => {
      clearInterval(interval);
    }
  }, [startedAt])

  return <div className={ `digital-display-wrapper digital-display-wrapper-${size}` }>
           <div className={ clsx("digital-display", { 'digital-display-negative': seconds < 0 }) }>
             { currentDisplay }
           </div>
         </div>
}
